export class Language {

    constructor(private info: { name: string, abbr: string, flag: string, dir:string , class? : string}){
  
    }
    get name() :string{
      return this.info.name;
    }
    get abbr() :string{
      return this.info.abbr;
    }
    get flag() :string{
      return this.info.flag;
    }
    get dir() :string{
      return this.info.dir;
    }
    get class() :string{
      return this.info.class ?? '';
    }
  }
  